import { render, staticRenderFns } from "./AddAlbum.vue?vue&type=template&id=1bda59af"
import script from "./AddAlbum.vue?vue&type=script&lang=js"
export * from "./AddAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bda59af')) {
      api.createRecord('1bda59af', component.options)
    } else {
      api.reload('1bda59af', component.options)
    }
    module.hot.accept("./AddAlbum.vue?vue&type=template&id=1bda59af", function () {
      api.rerender('1bda59af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/AddAlbum.vue"
export default component.exports